<template>
  <div
    class="modal-header text-size-m"
    :class="{
      'modal-header--shadow': shadowed,
    }"
    :style="{
      height: `${height}px`,
    }"
  >
    <div class="modal-header__head" @click="$emit('head-click')" ref="headRef">
      <slot name="head">
        <span class="text-red">
          {{ $t`Закрыть` }}
        </span>
      </slot>
    </div>
    <div class="modal-header__title" ref="titleRef">
      <slot name="title">
        <span class="text-center font-medium">
          {{ title }}
        </span>
      </slot>
    </div>
    <div
      class="modal-header__tail text-red"
      @click="$emit('tail-click')"
      ref="tailRef"
    >
      <slot name="tail"></slot>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import { onMounted } from "@vue/runtime-core";
export default {
  props: {
    height: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    shadowed: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const titleRef = ref(null);
    const headRef = ref(null);
    const tailRef = ref(null);

    onMounted(() => {
      const leftOffset = headRef.value.getBoundingClientRect().width;
      const rightOffset = tailRef.value.getBoundingClientRect().width;

      titleRef.value.style.padding = `0 ${Math.max(leftOffset, rightOffset)}px`;
    });

    return {
      titleRef,
      headRef,
      tailRef,
    };
  },
};
</script>

<style lang="scss" scoped>
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;

  &--shadow {
    border-bottom: 1px solid #dbdbdb;
  }

  &__head {
    position: absolute;
    padding: 16px;
  }

  &__title {
    flex: 1;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__tail {
    position: absolute;
    right: 0;
    padding: 0 15px;
  }
}
</style>
